var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_466:15619)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#D9E5EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.0001,
    cy: 50,
    r: 12.94,
    stroke: "#4F5F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6699 49.9997C70.6699 55.8927 65.8927 60.6699 59.9998 60.6699C54.1068 60.6699 49.3296 55.8927 49.3296 49.9997C49.3296 44.1068 54.1068 39.3296 59.9998 39.3296C65.8927 39.3296 70.6699 44.1068 70.6699 49.9997Z",
    stroke: "#4F5F6E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.9998,
    cy: 50,
    r: 15.18,
    stroke: "#4F5F6E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.0001,
    cy: 50,
    r: 21.9,
    stroke: "#4F5F6E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 42.5,
    width: 56,
    height: 15,
    rx: 7.5,
    fill: "#D9E5EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3693 53.112C47.6973 53.112 48.5133 52.48 48.5133 51.424C48.5133 50.536 47.9293 50.008 46.5373 49.68C45.6813 49.48 45.3853 49.264 45.3853 48.92C45.3853 48.552 45.7133 48.328 46.2493 48.328C46.8333 48.328 47.1853 48.632 47.1853 49.136H48.4093C48.4093 48.008 47.5613 47.288 46.2333 47.288C44.9453 47.288 44.1453 47.92 44.1453 48.944C44.1453 49.856 44.7613 50.4 46.0733 50.68C46.8653 50.848 47.2253 51.08 47.2253 51.472C47.2253 51.848 46.8893 52.064 46.3613 52.064C45.7453 52.064 45.3453 51.752 45.3453 51.216H44.0973C44.0973 52.376 44.9613 53.112 46.3693 53.112ZM52.2207 53H53.4927V48.592H55.2687V47.4H50.4447V48.592H52.2207V53ZM56.572 53H57.932L58.308 52.032H60.532L60.908 53H62.268L60.044 47.4H58.796L56.572 53ZM58.636 51.032L59.42 48.984L60.212 51.032H58.636ZM64.6157 53H65.8877V51.256H66.7277L67.7277 53H69.1997L68.0397 51.056C68.7117 50.76 69.1037 50.152 69.1037 49.328C69.1037 48.136 68.2877 47.4 67.0077 47.4H64.6157V53ZM65.8717 50.184V48.488H66.8397C67.4637 48.488 67.8157 48.792 67.8157 49.336C67.8157 49.88 67.4637 50.184 66.8397 50.184H65.8717ZM72.966 53H74.238V48.592H76.014V47.4H71.19V48.592H72.966V53Z",
    fill: "#4F5F6E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 42.5,
    width: 56,
    height: 15,
    rx: 7.5,
    stroke: "#4F5F6E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 11.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_466:15619",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.898039 0 0 0 0 0.92549 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_466:15619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_466:15619",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartFilled);
export default __webpack_public_path__ + "static/media/start_filled.949f08a4.svg";
export { ForwardRef as ReactComponent };